import {
  DatePickerWithInput,
  Pagination,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useBranchReport from "./useBranchReport";
import { FaSort } from "react-icons/fa";
import EmptyData from "../../../Global/EmptyData";
import Select from "react-select";
import CardHero from "../CardHero";
import CardHeroShimmer from "../CardHero/CardHeroShimmer";
import { Table } from "../../../Global/Table";
import TableShimmer from "../../../Global/Table/TableShimmer";

const BranchReport = ({ basicData }) => {
  const {
    loading,
    date,
    formik,
    cardData,
    isFetching,
    reportState,
    branchReportData,
    paginationOptions,
    customStaticRanges,
    getRow,
    handleSort,
    handlePageSize,
    handleDateChange,
    handleSearch,
    handlePagination,
    handleBranchFilter,
    handleSourceFilter,
    handleWorkStatusFilter,
    handleDownloadClick,
  } = useBranchReport();

  return (
    <div className="col-auto pro-pt-3 pro-pb-6">
      <div>
        <div className="col-12">
          <div className="row gx-2 gy-2 pro-items-end">
            <div className={`col-3`}>
              <div className="input-wrap">
                <input
                  type="text"
                  onChange={(e) => {
                    handleSearch(e);
                  }}
                  placeholder="Search GLI Number"
                  className={`pro-input icon-r lg`}
                  value={reportState?.otherReport?.search}
                />
                <span className="pro-icon">
                  {<span className="material-symbols-outlined">search</span>}
                </span>
              </div>
            </div>
            <div className={`col-3`}>
              <DatePickerWithInput
                CalendarOutlineIcon={
                  <span className="material-symbols-outlined">
                    calendar_month
                  </span>
                }
                range={true}
                initialValue={date}
                onDateChange={handleDateChange}
                datePickerProps={{
                  staticRanges: customStaticRanges,
                  inputRanges: [],
                }}
                maxDate={new Date()}
              ></DatePickerWithInput>
            </div>
            <div className="col-3">
              <div className="input-wrap ">
                <label
                  htmlFor="branch"
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Branch
                </label>
                <Select
                  id="branch"
                  placeholder={"Select"}
                  className={"pro-input lg"}
                  classNamePrefix="pro-input"
                  name="branch"
                  options={basicData?.branch_list}
                  getOptionValue={(option) => option?._id}
                  getOptionLabel={(option) => option?.branch_name}
                  value={basicData?.branch_list?.filter((p) =>
                    reportState?.otherReport?.currentTempBranchFilter?.includes(
                      p._id
                    )
                  )}
                  onChange={(value) =>
                    // formik.setFieldValue("branch", value)
                    handleBranchFilter(value)
                  }
                  menuPlacement="auto"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="input-wrap ">
                <label
                  htmlFor="source"
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Source
                </label>
                <Select
                  id="source"
                  placeholder={"Select"}
                  className={"pro-input lg"}
                  classNamePrefix="pro-input"
                  name="source"
                  isMulti
                  options={basicData?.source}
                  getOptionValue={(option) => option?._id}
                  getOptionLabel={(option) => option?.source_name}
                  value={basicData?.source?.filter((p) =>
                    reportState?.otherReport?.currentSourceFilter?.includes(
                      p._id
                    )
                  )}
                  onChange={(value) =>
                    handleSourceFilter(value?.map((v) => v._id))
                  }
                  menuPlacement="auto"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="input-wrap ">
                <label
                  htmlFor="work_status"
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Work Status
                </label>
                <Select
                  id="work_status"
                  placeholder={"Select"}
                  className={"pro-input lg"}
                  classNamePrefix="pro-input"
                  name="work_status"
                  isMulti
                  options={basicData?.work_status}
                  getOptionValue={(option) => option?.id}
                  getOptionLabel={(option) => option?.name}
                  value={basicData?.work_status?.filter((p) =>
                    reportState?.otherReport?.currentWorkStatusFilter?.includes(
                      p.id
                    )
                  )}
                  onChange={(value) =>
                    handleWorkStatusFilter(value?.map((v) => v.id))
                  }
                  menuPlacement="auto"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="input-wrap">
                <label
                  htmlFor="order_type"
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Order Type
                </label>
                <Select
                  id="order_type"
                  placeholder={"Select"}
                  className={"pro-input lg"}
                  classNamePrefix="pro-input"
                  name="order_type"
                  options={basicData?.order_types}
                  getOptionValue={(option) => option?.id}
                  getOptionLabel={(option) => option?.name}
                  value={formik?.values?.order_type}
                  onChange={(value) =>
                    formik.setFieldValue("order_type", value)
                  }
                  menuPlacement="auto"
                />
              </div>
            </div>
            <div className="col-auto pro-ms-auto">
              <button
                className={`pro-btn pro-btn-primary lg${loading && " loading"}`}
                onClick={handleDownloadClick}
                disabled={!formik?.values?.order_type}
              >
                <span class="material-symbols-outlined x2">download</span>
                <span>Export</span>
              </button>
            </div>
          </div>
        </div>
        {isFetching ? (
          <div className="pro-mt-4">
            <CardHeroShimmer count={cardData?.length || 8} />
            <div className="pro-mt-4">
              <TableShimmer
                perpage={reportState?.otherReport?.currentPageSize}
                feilds={branchReportData?.data?.fields?.length || 5}
              />
            </div>
          </div>
        ) : branchReportData?.data?.data?.length > 0 ? (
          <div className="pro-mt-4">
            <CardHero data={cardData} />
            <Table
              multiSelect={false}
              data={branchReportData?.data?.data || []}
              uniqueID={"id"}
              fields={branchReportData?.data?.fields}
              SortIcon={<FaSort />}
              handleSort={handleSort}
              getRow={getRow}
              loading={isFetching}
              perpage={reportState?.otherReport?.currentPageSize}
              assignable={false}
              editable={false}
              deletable={false}
              showCheckBox={false}
              tabFilter={true}
            />
            {branchReportData?.data?.data?.length > 0 && (
              <Pagination
                currentPage={reportState?.otherReport?.currentPage}
                totalPageCount={Math.ceil(
                  branchReportData?.data?.total_count /
                    reportState?.otherReport?.currentPageSize
                )}
                onPageChange={handlePagination}
                options={paginationOptions}
                onActionChange={handlePageSize}
                center
              />
            )}
          </div>
        ) : (
          <EmptyData />
        )}
      </div>
    </div>
  );
};

export default BranchReport;
